import React, { Component } from 'react'
import { connect } from 'react-redux'
import { loginUser } from '../../actions'
import Loader from '../_common/Loader'

// import logo from '../../assets/img/img_logo.png'
import logo from '../../assets/img/logo.png'

class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userID: '',
      password: ''
    }
  }

  _handleLoginSubmit (e) {
    e.preventDefault()
    const { userID, password } = this.state
    this.props.loginUser(userID, password)
  }

  _handleIdChange (e) {
    this.setState({userID: e.target.value})
  }

  _handlePasswordChange (e) {
    this.setState({password: e.target.value})
  }

  _renderLoader () {
    if (this.props.user && this.props.user.loading) {
      return (
        <div className="loader_container">
          <Loader classname="loader_dot_horizontal loader_dot"/>
        </div>
      )
    }
    return null
  }

  render () {
    return (
      <main id="login" className="flex justify-center align-center">
        <div className="inner_container flex column justify-center align-center">
          <div className="img_container">
            <img className="logo_img" src={logo} alt="Buffalo IT Solutionsのロゴ"/>
          </div>
          <fieldset disabled={ this.props.user && this.props.user.loading }>
            <form onSubmit={this._handleLoginSubmit.bind(this)}>
              {
                (this.props.user && this.props.user.error)
                  ? <div className="error_container">サーバエラー</div>
                  : null
              }
              <div className="input-group flex column">
                <label htmlFor="userID">id</label>
                <input
                  type="text"
                  id="userID"
                  placeholder="ID"
                  value={this.state.userID}
                  onChange={this._handleIdChange.bind(this)}
                />
              </div>
              <div className="input-group flex column">
                <label htmlFor="password">password</label>
                <input
                  type="password"
                  id="password"
                  placeholder="PASSWORD"
                  value={this.state.password}
                  onChange={this._handlePasswordChange.bind(this)}
                />
              </div>
              <div className="error_msg small text-center"></div>
              <div className="flex justify-center">
                <button className="submit_btn btn primary" type="submit">
                  <span>ログイン</span>
                  { this._renderLoader() }
                </button>
              </div>
            </form>
          </fieldset>
        </div>
      </main>
    )
  }
}

function mapStateToProps ({ user }) {
  return { user }
}

export default connect(mapStateToProps, { loginUser })(Login)



// WEBPACK FOOTER //
// ./src/components/Login/index.js